export const EmptyImg = ' ../../../assets/images/smart/no-bookings.png';

export type BookingType = 'Standard' | 'WithCredit';
